import React from 'react';
import { displayRange, displayRangeShort } from '../utils/dates';

export default function PeriodSummary({ timesheet, periodTotal, expectedHours, entryCount }) {
  if (!timesheet) return null;

  const variance = periodTotal - (expectedHours || 0);
  const varianceColor = variance > 0 ? '#059669' : variance < 0 ? '#dc2626' : 'inherit';
  const varianceStr = variance >= 0 ? `+${variance.toFixed(1)}` : variance.toFixed(1);

  return (
    <div className="period-summary">
      <div className="period-summary-item">
        <div className="period-summary-value">
          {/* Short form on phones so the range doesn't wrap. */}
          <span className="range-long">{displayRange(timesheet.PeriodStart, timesheet.PeriodEnd)}</span>
          <span className="range-short">{displayRangeShort(timesheet.PeriodStart, timesheet.PeriodEnd)}</span>
        </div>
        <div className="period-summary-label">
          {timesheet.Status && (
            <span className={`ts-status ${timesheet.Status.toLowerCase()}`} style={{
              fontSize: '10px',
              padding: '1px 8px',
            }}>
              {timesheet.Status}
            </span>
          )}
        </div>
      </div>
      <div className="period-summary-item">
        <div className="period-summary-value">
          {periodTotal.toFixed(1)}
          <span style={{ fontSize: '11px', marginLeft: '4px', color: varianceColor }}>
            ({varianceStr})
          </span>
        </div>
        <div className="period-summary-label">Total Hours</div>
      </div>
      <div className="period-summary-item">
        <div className="period-summary-value">{entryCount}</div>
        <div className="period-summary-label">Entries</div>
      </div>
    </div>
  );
}
